import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Removed "./index.css" import since the file doesn't exist
// App.css is already imported in App.js

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);